import FallBackImg from '../assets/images/fallback.jpg';

function normalizeImgBase(): string {
  const raw = process.env.REACT_APP_IMG_ENDPOINT ?? '';
  return raw.trim().replace(/^["']|["']$/g, '');
}

const imgBase = normalizeImgBase();

type TrackLike = {
  thumbnail?: string;
  artwork?: string;
};

/** 미니플레이어·플레이어·재생목록 썸네일 URL (thumbnail 우선) */
export function getTrackImageUrl(track: TrackLike | null | undefined): string {
  if (!track) return FallBackImg;
  const file = (track.thumbnail || track.artwork || '').trim();
  if (!file) return FallBackImg;
  if (file.startsWith('http://') || file.startsWith('https://')) return file;
  if (!imgBase) return FallBackImg;
  const path = file.replace(/^\//, '');
  return `${imgBase.replace(/\/$/, '')}/${path}`;
}

export function getDoctorImageUrl(image?: string): string {
  const file = (image || '').trim();
  if (!file) return FallBackImg;
  if (file.startsWith('http://') || file.startsWith('https://')) return file;
  if (!imgBase) return FallBackImg;
  return `${imgBase.replace(/\/$/, '')}/${file.replace(/^\//, '')}`;
}
